// Copyright © 2021 Move Closer
import { Site } from '../../_contracts';
/**
 * Registry that binds the `Site` with the corresponding logotype filename.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const siteLogoClassNameRegistry = {
    [Site.CyberDefence24]: 'cyber-defence',
    [Site.Defence24]: 'defence-24',
    [Site.Defence24COM]: 'defence-24-com',
    [Site.Defence24MSPO]: 'defence-24-mspo',
    [Site.Energetyka24]: 'energetyka-24',
    [Site.InfoSecurity24]: 'info-security-24',
    [Site.Space24]: 'space-24',
    [Site.KadeciRP]: 'kadecirp'
};
